import { required, requiredIf, maxLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

// select2 ที่อยู่ใช้ '0' เป็น option "เลือก..." → ถือว่ายังไม่ได้เลือก
const selected = helpers.regex(/^(?!0$).+$/);

/**
 * ใบกำกับภาษีเต็มรูป (ประมวลรัษฎากร ม.86/4) ต้องมี ชื่อ + ที่อยู่ ของผู้ซื้อเสมอ
 *
 * ส่วน "สำนักงานใหญ่ / สาขาที่ ..." มาจากประกาศอธิบดีฯ (ฉบับที่ 197) ซึ่งบังคับเฉพาะ
 * กรณีผู้ซื้อเป็น "ผู้ประกอบการจดทะเบียน VAT" — บุคคลธรรมดาไม่มีสาขา จึงไม่บังคับ
 * (ฟอร์มซ่อนช่องนั้นไปเลยเมื่อเลือกประเภทลูกค้าเป็นบุคคลธรรมดา)
 */
export default function (formState) {
  const isJuristic = () => formState.customer_type === 'juristic';

  return {
    form: {
      customer_name: {
        required: helpers.withMessage(i18n.global.t('Please enter the customer name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Customer name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
      },
      customer_tax_id: {
        required: helpers.withMessage(i18n.global.t('Please enter the customer Tax ID.'), required),
        pattern: helpers.withMessage(i18n.global.t('Tax ID must be 13 digits.'), helpers.regex(/^\d{13}$/)),
      },
      customer_branch: {
        requiredIfJuristic: helpers.withMessage(
          i18n.global.t('Please enter a branch number.'),
          requiredIf(isJuristic)
        ),
        pattern: helpers.withMessage(i18n.global.t('Branch number must be 5 digits.'), helpers.regex(/^\d{5}$/)),
      },
      address: {
        required: helpers.withMessage(i18n.global.t('Please enter the address.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Address cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
      },
      postal_code: {
        required: helpers.withMessage(i18n.global.t('Please enter the zipcode.'), required),
        pattern: helpers.withMessage(i18n.global.t('Zipcode must be 5 digits.'), helpers.regex(/^\d{5}$/)),
      },
      sub_district: {
        required: helpers.withMessage(i18n.global.t('Please select a sub-district.'), required),
        selected: helpers.withMessage(i18n.global.t('Please select a sub-district.'), selected),
      },
      district: {
        required: helpers.withMessage(i18n.global.t('Please select a district.'), required),
        selected: helpers.withMessage(i18n.global.t('Please select a district.'), selected),
      },
      province: {
        required: helpers.withMessage(i18n.global.t('Please select a province.'), required),
        selected: helpers.withMessage(i18n.global.t('Please select a province.'), selected),
      },
      customer_type: {}
    }
  }
};
